/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type CurrencySelector_user$ref = any;
type CurrencySelector_viewer$ref = any;
export type FooterBottomRow_viewer$ref = any;
export type FooterBottomRow_viewer = {
    readonly user?: {
        readonly " $fragmentRefs": CurrencySelector_user$ref;
    } | null;
    readonly " $fragmentRefs": CurrencySelector_viewer$ref;
    readonly " $refType": FooterBottomRow_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "FooterBottomRow_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "userId",
            "type": "String!"
        },
        {
            "kind": "RootArgument",
            "name": "hasUserId",
            "type": "Boolean"
        }
    ],
    "selections": [
        {
            "kind": "Condition",
            "passingValue": true,
            "condition": "hasUserId",
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "user",
                    "storageKey": null,
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "userId",
                            "variableName": "userId"
                        }
                    ],
                    "concreteType": "User",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "CurrencySelector_user",
                            "args": null
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "CurrencySelector_viewer",
            "args": null
        }
    ]
} as any);
(node as any).hash = 'e2b922f152c8b16822665165dff91495';
export default node;
